import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyHeading, MyGlobal, MyAlert } from '../../GlobalContext';

export class RF_TransferDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            loading: true,
            alertMessage: "",
            rfTransfer: this.props.rfTransfer,
            client: this.props.selectedClient,
            namecode: this.props.rfTransfer.namecode,
            docket: this.props.rfTransfer.docket,
            rfStatus: this.props.rfTransfer.rfStatus,
            transferRef: "",
            rfTransferLines: [],
            
        };

    }

    componentDidMount() {
        this.loadTransferDetails();
    }
    loadTransferDetails() {

        this.setState({ loading: true });
   
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.rfTransfer)
        };

        fetch(`api/Transfer/GetTransferLines`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result && result.success) {
                    this.setState({
                        rfTransferLines: result.data,
                        loading: false
                    });
                } else {
                    throw new Error(result.errorMessage || "Failed to load transfer details");
                }
            })
            .catch(error => {
                this.setState({ alertMessage: "Failed to load transfer details: " + error.message, loading: false });
            });
    }

    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Product Code</th>
                        <th>Description</th>
                        <th>PackDesc</th>
                        <th>Units</th>
                        <th>Location</th>

                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) =>
                        <tr key={index}>
                            <td>{row.productCode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.packDescription}</td>
                            <td>{row.units}</td>
                            <td>{row.location}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {

      
        let loadingProgress = this.state.loading ? <Container><Row><Col><p><em>Loading...</em></p> </Col></Row></Container> : <p></p>;

        const alertMessage = this.state.alertMessage;
        const formatAlertMessage = message => {
            if (typeof message !== 'string') {
                return null;
            }
            return message.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line.split('**').map((part, i) =>
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                    )}
                    <br />
                </React.Fragment>
            ));
        };
        let transferLines = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.rfTransferLines);


        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered size="xl">

                    <Modal.Header>
                        <Modal.Title>Transfers History</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        {loadingProgress}
                        <Container>
                            <Row>
                                <Col>
                                    {alertMessage !== "" && (
                                        <MyAlert variant="danger">
                                            {formatAlertMessage(alertMessage)}
                                        </MyAlert>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={12}>
                                    <label>Client : {this.state.client}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={12}>
                                    <label>Docket : {this.state.docket}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={12}>
                                    <label>RF Status : {this.state.rfStatus}</label>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col xs={12}> <h5> Transfer Lines </h5></Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="tableHolder hm-50vh mb-3">
                                        {transferLines}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-success col-12 mb-2" onClick={this.props.onClickClose}>
                            Close
                        </Button>
                    </Modal.Footer>

                </Modal>
            </>
        );
    }
}

export default RF_TransferDetails;